var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 22.0078C17.5228 22.0078 22 17.5307 22 12.0078C22 6.48496 17.5228 2.00781 12 2.00781C6.47715 2.00781 2 6.48496 2 12.0078C2 17.5307 6.47715 22.0078 12 22.0078Z",
    fill: "#4A4B68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.9375C9.93 6.9375 8.25 8.6175 8.25 10.6875C8.25 12.7175 9.84 14.3675 11.95 14.4275C11.98 14.4275 12.02 14.4275 12.04 14.4275C12.06 14.4275 12.09 14.4275 12.11 14.4275C12.12 14.4275 12.13 14.4275 12.13 14.4275C14.15 14.3575 15.74 12.7175 15.75 10.6875C15.75 8.6175 14.07 6.9375 12 6.9375Z",
    fill: "#4A4B68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7807 19.3622C17.0007 21.0022 14.6207 22.0122 12.0007 22.0122C9.3807 22.0122 7.0007 21.0022 5.2207 19.3622C5.4607 18.4522 6.1107 17.6222 7.0607 16.9822C9.7907 15.1622 14.2307 15.1622 16.9407 16.9822C17.9007 17.6222 18.5407 18.4522 18.7807 19.3622Z",
    fill: "#4A4B68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.ccb51c0b9a89f0a750900bd7657a2ae5.svg";
export { ForwardRef as ReactComponent };